import { Injectable } from '@angular/core';
import { InvoiceIndividualDetailModel } from 'src/app/core/models/individual-model';
import { PaymentAddressView } from 'src/app/core/models/payment-models/payment-address.model';

@Injectable()
export class PaymentDocumentInvoiceMapper {
z
    public invoiceIndividualToPaymentAddress(invoiceIndividual: InvoiceIndividualDetailModel): PaymentAddressView {
        let invoiceAddress = invoiceIndividual?.InvoiceAddress;
        let address: PaymentAddressView = {
            addressId: invoiceAddress?.addressId,
            individualId: invoiceIndividual?.individualId,
            addressTypeCode: invoiceAddress?.addressTypeCode,
            useAddressId: invoiceAddress?.useAddressId,
            countryCode: invoiceAddress?.countryCode,
            addressLine1: invoiceAddress?.addressLine1,
            addressLine2: invoiceAddress?.addressLine2,
            postalCode: invoiceAddress?.postalCode,
            state: invoiceAddress?.state,
            province: invoiceAddress?.province,
            city: invoiceAddress?.city,
            locationId: invoiceAddress?.locationId,
        }
        return address;
    }
}